const CONFIGURATION_TYPE = Object.freeze({
  FULL: 'full',
  PROJECT: 'project',
});

const MAX_FILE_SIZE = 10485760;
const MAX_FILES = 5;

export { CONFIGURATION_TYPE, MAX_FILE_SIZE, MAX_FILES };
